import featuredItemsSection from './featuredItemsSection'

export default featuredItemsSection
